var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4444 2.6H15.0982C14.5705 1.0881 13.1662 0 11.5 0C9.83378 0 8.4295 1.0881 7.90178 2.6H2.55556C1.14361 2.6 0 3.7635 0 5.2V23.4C0 24.8365 1.14361 26 2.55556 26H20.4444C21.8564 26 23 24.8365 23 23.4V5.2C23 3.7635 21.8564 2.6 20.4444 2.6ZM11.5 2.6C12.2053 2.6 12.7778 3.1824 12.7778 3.9C12.7778 4.6176 12.2053 5.2 11.5 5.2C10.7947 5.2 10.2222 4.6176 10.2222 3.9C10.2222 3.1824 10.7947 2.6 11.5 2.6ZM7.66667 20.8H5.11111V18.2L12.9643 10.2102L15.5199 12.8102L7.66667 20.8ZM17.3599 10.9382L16.4246 11.8898L13.869 9.2898L14.8043 8.3382C15.5097 7.6206 16.6546 7.6206 17.3599 8.3382C18.0652 9.0558 18.0652 10.2206 17.3599 10.9382Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.2b45c3ed052aa7cd5e682ff52641915d.svg";
export { ForwardRef as ReactComponent };